<template>
  <el-row>
    <el-col :span="24">
      <div v-for="(option, i) in item.body.options" :key="i">
        <el-radio v-model="value" :value="option" v-validate="i==0 &&item.isRequired  ?'required': ''" :label="option" :name="item.id" style="white-space: pre-line;display: inline-flex;">{{option}}</el-radio>
      </div>
      <div>
        <el-radio v-if="item.body.addOtherOption" v-model="value" :name="item.id" ref="otherOption" :label="`other#`">Khác</el-radio>
      </div>
      <div style="margin-top:5px;" v-if="value.indexOf('other#') > -1">
        <el-input :name="item.body.placeholderOtherOptionPre" :placeholder="item.body.placeholderOtherOption" v-model="otherValue" @blur="handleOtherValue()" />
      </div>
      <div v-if="errors.has(item.id)" style="color:red">{{$t(`requiredChoose`)}}</div>
    </el-col>
  </el-row>
</template>
<script>
import { findIndex, map, filter } from 'lodash'
import Vue from 'vue'
export default {
  data() {
    return {
      value: '',
      otherValue: '',
      otherChecked: false
    }
  },
  inject: ['parentValidator'],
  methods: {
    sendDataSurvey(data) {
      var _this = this
      _this.$store.commit('editSurvey', data)
    },
    handleOtherValue() {
      var _this = this
      _this.sendDataSurvey({ surveyDetailId: _this.item.id, values: ['other#' + _this.otherValue] })
    }
  },
  watch: {
    value: function() {
      var _this = this
      _this.sendDataSurvey({
        surveyDetailId: _this.item.id,
        values: [_this.value != 'other#' ? _this.value : 'other#' + _this.otherValue]
      })
    }
  },
  created() {
    var _this = this
    this.$validator = this.parentValidator
  },
  props: ['item']
}
</script>

